import $ from 'jquery';

$(document).ready(function () {
    if (document.getElementsByClassName('js-read-more').length > 0) {
        var labelMore = '<a class="link" href="#">Leggi tutto</a>';
        var labelLess = '<a class="link" href="#">Chiudi</a>';
        var lang = $('html').attr('lang');
        if (lang.startsWith('en-')) {
            labelMore = '<a class="link" href="#">Read more</a>';
            labelLess = '<a class="link" href="#">Close</a>';
        }
        if (lang === 'es-ES') {
            labelMore = '<a class="link" href="#">Leer más</a>';
            labelLess = '<a class="link" href="#">Cerrar</a>';
        }
        if (lang === 'fr-FR') {
            labelMore = '<a class="link" href="#">Lire plus</a>';
            labelLess = '<a class="link" href="#">Fermer</a>';
        }
        if (lang === 'de-DE') {
            labelMore = '<a class="link" href="#">Alles lesen</a>';
            labelLess = '<a class="link" href="#">Schließen</a>';
        }

        new Readmore('.js-read-more', {
            maxHeight: 100,
            moreLink: labelMore,
            lessLink: labelLess,
            embedCSS: true,
            blockCSS: 'display: inline-block; margin-bottom: 1em;',
        });
    }
});
